<div *ngIf="ticketId "
     class="position-button  z-[9999] flex flex-col items-center">

  <div class="relative flex flex-col items-center">

    <!-- Bouton rond style taxi -->
    <button class="w-14 h-14 rounded-full bg-yellow-400 shadow-lg 
                   flex items-center justify-center text-black hover:bg-yellow-300 transition duration-200 "
                   (click)="showTicketAction()"
           >

      <!-- Icône taxi Material Icons -->
          <span class="material-icons text-4xl" style="width: 100%;">download</span>

    </button>

    <!-- Message top-right, width fit-content -->
    <div class="absolute -top-10 -right-10">
      <div class="bg-white border border-gray-300 shadow-md rounded-lg 
                  text-sm text-gray-800 px-3 py-2 truncate w-max">
        <span>
          {{ 'download_ticket' | translate }}
        </span>
      </div>
    </div>

  </div>
</div>
